/**
 * Selected-chip content for the interviewer Select — avatar + name on
 * the left, timezone clock on the right. Used via
 * `renderTriggerValue` on the async Select.
 */
import { Flex, Text } from '@chakra-ui/react';
import { Avatar } from '@kula-ai/components';
import { InterviewerCalNotConnected } from './InterviewerCalNotConnected';
import { InterviewerTimezoneTrigger } from '../../timezoneModal';

interface InterviewerTriggerChipProps {
  label: string;
  image?: string;
  /** Pre-formatted "10:30 AM PST" clock; empty when tz is unknown. */
  clock?: string;
  /** When true, renders a warning icon before the avatar with a hover
   *  tooltip explaining the interviewer's calendar isn't connected. */
  calendarNotConnected?: boolean;
  /** Fires when the user clicks "Set timezone" on the missing-tz popover. */
  onSetTimezone?: () => void;
}

export function InterviewerTriggerChip({
  label,
  image,
  clock,
  calendarNotConnected,
  onSetTimezone,
}: InterviewerTriggerChipProps) {
  return (
    <Flex align="center" gap="2" w="100%" minW={0}>
      {!clock && onSetTimezone && (
        <InterviewerTimezoneTrigger onSetTimezone={onSetTimezone} />
      )}
      {calendarNotConnected && <InterviewerCalNotConnected />}
      <Avatar src={image} name={label} size="xs" shape="square" />
      <Text
        fontSize="sm"
        color="secondary-900"
        fontWeight="medium"
        noOfLines={1}
        flex="1"
        minW={0}
      >
        {label}
      </Text>
      {clock ? (
        <Text fontSize="xs" color="secondary-500" flexShrink={0}>
          {clock}
        </Text>
      ) : null}
    </Flex>
  );
}
